<template>
  <ul class="social-icons nav nav-navbar nav-transform-none d-flex flex-row">
    <li v-if="!isEmpty(currentScopedCompanyPage.linkedin_id)" class="nav-item">
      <a
        class="nav-link px-2"
        target="_blank"
        :href="`https://www.linkedin.com/company/${currentScopedCompanyPage.linkedin_id}`"
      >
        <i class="fab fa-linkedin" />
      </a>
    </li>

    <li v-if="!isEmpty(currentScopedCompanyPage.fb_url)" class="nav-item">
      <a
        class="nav-link px-2"
        target="_blank"
        :href="currentScopedCompanyPage.fb_url"
      >
        <i class="fab fa-facebook-square" />
      </a>
    </li>

    <li v-if="!isEmpty(currentScopedCompanyPage.instagram)" class="nav-item">
      <a
        class="nav-link px-2"
        target="_blank"
        :href="`https://instagram.com/${currentScopedCompanyPage.instagram}`"
      >
        <i class="fab fa-instagram" />
      </a>
    </li>

    <li v-if="!isEmpty(currentScopedCompanyPage.video_channel_url)" class="nav-item">
      <a
        class="nav-link px-2"
        target="_blank"
        :href="currentScopedCompanyPage.video_channel_url"
      >
        <i class="fab fa-youtube" />
      </a>
    </li>

    <li v-if="!isEmpty(currentScopedCompanyPage.terms_of_service_url)" class="nav-item">
      <a
        class="nav-link px-2"
        target="_blank"
        :href="`${currentScopedCompanyPage.terms_of_service_url}`"
      >
        <i class="fas fa-info-circle" />
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SocialMediaIcons',
  props: {
    currentScopedCompanyPage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      message: 'Social Media Icons',
    };
  },
  methods: {
    isEmpty(value) {
      return value === null || value === undefined || value === '';
    },
  },
 };
</script>

<style scoped lang="scss">
  .social-icons {
    li {
      font-size: 17px;
    }
  }
</style>
